import { useEffect, useState } from 'react'
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  Badge,
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import TableWithButtons from '../../../../components/customTable/basic/TableWithButtons'
// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'

import { useDispatch, useSelector } from 'react-redux'
import CurrencyInput from 'react-currency-input-field'
import { ApartmentAreaTypes } from '../store/types'
import { Link } from 'react-router-dom'

const SingleDebtEntry = ({
  values,
  handleSubmit,
  selectedDebtor,
  setSelectedDebtor,
  debtEntryCheck,
  setDebtEntryCheck,
  resetForm,
}) => {
  const dispatch = useDispatch()
  const apartments = useSelector(
    (state) => state.AreaDebtSlice.apartmentsAreaDebt
  )
  const debts_error = useSelector((state) => state.AreaDebtSlice.debts_error)
  const is_filter_load = useSelector(
    (state) => state.AreaDebtSlice.is_filter_load
  )
  const [topLand, setTopLand] = useState(0)
  const { t } = useTranslation()
  const [debtInput, setDebtInput] = useState([])

  const columns = [
    {
      name: t('Bina'),
      sortable: true,
      selector: (row) => row.building,
    },
    {
      name: t('Daire No'),
      sortable: true,
      selector: (row) => row.identifier,
      width: '150px',
    },
    {
      name: t('Durumu'),
      sortable: true,
      selector: (row) => row.status,
    },
    {
      name: t('Tam Adı'),
      sortable: true,
      selector: (row) => row.full_name,
      width: '220px',
    },
    {
      name: t('Area'),
      sortable: true,
      selector: (row) => row.area,
    },
    { name: t('Tutar'), selector: (row) => row.button },
  ]
  const data = () => {
    return debtInput?.map((item) => ({
      apartmentId: item.apartment_id,
      building: item.building,
      identifier: (
        <Link to={`/apps/daire-detaylari/${item.apartment_id}`}>
          {' '}
          {item.identifier}
        </Link>
      ),
      status: item.resident_apartments.map((resident) =>
        resident.id ===
          selectedDebtor.find(
            (select) =>
              select.res_id === resident.id &&
              select.apartment_id === item.apartment_id &&
              select.selected === true
          )?.res_id && resident.apartment_id === item.apartment_id
          ? resident.type === 1
            ? t('Kat Maliki')
            : resident.type === 2
            ? t('Kiracı')
            : resident.type === 3
            ? t('Hissedar')
            : ''
          : ''
      ),
      full_name: (
        <select
          style={{
            background: 'transparent',
            border: 'none',
            padding: '10px',
            color: '#b4b7bd',
            width: '150px',
          }}
          onChange={(e) => {
            selectedDebtor.map((selected) =>
              selected.res_id === parseInt(e.target.value) &&
              item.apartment_id === selected.apartment_id
                ? (selected.selected = true)
                : selected.res_id !== parseInt(e.target.value) &&
                  item.apartment_id === selected.apartment_id
                ? (selected.selected = false)
                : ''
            )
            setSelectedDebtor([...selectedDebtor])
          }}
        >
          {item.resident_apartments?.map((res) => (
            <>
              <option
                value={res.id}
                selected={
                  res.id ===
                  selectedDebtor.find(
                    (el) =>
                      el.apartment_id === item.apartment_id &&
                      el.res_id === res.id &&
                      el.selected === true
                  )?.res_id
                    ? true
                    : false
                }
              >
                {' '}
                {res.resident?.name + res.resident?.surname}
              </option>
            </>
          ))}
        </select>
      ),
      area: (
        <span>
          {item.area} m <sup>2</sup>
        </span>
      ),
      button: (
        <CurrencyInput
          autocomplete="off"
          intlConfig={{ locale: 'tr-TR', currency: 'TRY' }}
          id="input-example"
          name="input-name"
          placeholder={t('Tutar')}
          value={
            selectedDebtor.find((el) => el.apartment_id === item.apartment_id)
              ?.amount
          }
          decimalsLimit={2}
          className="form-control"
          style={{
            background: 'transparent',
            border: 'none',
            padding: '15px',
            width: '140px',
          }}
          onValueChange={(e) => {
            selectedDebtor.map((selected) =>
              selected.apartment_id === item.apartment_id
                ? (selected.amount = e)
                : ''
            )
            setSelectedDebtor([...selectedDebtor])
          }}
        />
      ),
    }))
  }
  const errorColumns = [
    {
      name: t('Building'),
      sortable: true,
      selector: (row) => row.building_identifier,
    },
    {
      name: t('No'),
      sortable: true,
      selector: (row) => row.apartment_identifier,
    },
    {
      name: t('Açıklama'),
      sortable: false,
      selector: (row) => row.description,
    },
    {
      name: t('Tutar'),
      sortable: false,
      selector: (row) => row.amount,
    },
    {
      name: t('Durum'),
      sortable: false,
      selector: (row) => row.status,
    },
  ]
  const errorData = debts_error?.map((item) => ({
    apartmentId: item.apartment_id,
    building_identifier: item.building_identifier,
    apartment_identifier: (
      <Link to={`/apps/daire-detaylari/${item.apartment_id}`}>
        {item.apartment_identifier}
      </Link>
    ),
    description: item.is_success ? (
      <div>{t('Borç Başarıyla Girildi')}</div>
    ) : (
      <div>{item.message}</div>
    ),
    amount: `${item.amount} TL`,
    status: (
      <div className="">
        {item.is_success ? (
          <Badge color="success">{t('Başarılı')}</Badge>
        ) : (
          <Badge color="danger">{t('Başarısız')}</Badge>
        )}
      </div>
    ),
  }))
  let topAreaa = 0
  useEffect(() => {
    dispatch({
      type: ApartmentAreaTypes.SHOW_APARTMENT_AREA_DEBT,
      payload: { id: values?.buildings },
    })
  }, [dispatch, values.buildings?.length > 0 ? values : null])
  useEffect(() => {
    setSelectedDebtor([])
    setDebtInput(
      apartments?.map(
        (item) => (
          (topAreaa += item.area),
          {
            apartment_id: item.id,
            identifier: item.identifier,
            land: item.area,
            area: item.area,
            building: item.building?.name,
            amount: values.amount,
            resident_apartments: item.resident_apartments,
          }
        )
      )
    )
    setTopLand(topAreaa)
    apartments?.map((apartment) =>
      apartment.resident_apartments.map((item) =>
        selectedDebtor.findIndex(
          (el) => el.apartment_id === item.apartment_id && el.res_id === item.id
        ) >= 0
          ? ''
          : selectedDebtor.push({
              apartment_id: item.apartment_id,
              building_id: apartment.building_id,
              building_name: apartment.building?.name,
              res_id: item.id,
              resident_id: item.resident.id,
              amount: (values.amount / topAreaa) * apartment.area,
              identifier: apartment.identifier,
              type: item.type,
              area: apartment.area,
              land: apartment.land,
              selected:
                apartment.resident_apartments.length === 1
                  ? true
                  : item.type === 2
                  ? true
                  : false,
            })
      )
    )
    selectedDebtor.map(
      (item) => (
        (item.amount =
          values.amountType === 1
            ? Math.floor((values.amount / topAreaa) * item.area).toFixed(2)
            : ((values.amount / topAreaa) * item.area).toFixed(2)),
        setSelectedDebtor([...selectedDebtor])
      )
    )
  }, [apartments, values.amount, values.amountType])
  return (
    <Col sm="12" md={9} className="d-block">
      <TableWithButtons
        columns={columns}
        loading={is_filter_load}
        data={data(values.amount)}
      >
        <div
          style={{
            width: 'auto',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
          }}
        >
          {selectedDebtor?.length > 0 ? (
            <Button type="submit" color="primary" onClick={handleSubmit}>
              {t('Borç Gir')}
            </Button>
          ) : (
            ''
          )}
        </div>
      </TableWithButtons>
      <Modal
        isOpen={
          debtEntryCheck ? (debts_error?.length > 0 ? true : false) : false
        }
        toggle={() => setDebtEntryCheck(false)}
        className="modal-dialog-centered modal-lg"
      >
        <ModalHeader
          className="bg-transparent"
          toggle={() => {
            resetForm()
            setDebtEntryCheck(false)
          }}
        ></ModalHeader>
        <div className="text-center mb-2">
          <h1 className="mb-1"> {t('Borç Mesajı')}</h1>
        </div>
        <Row tag="form" className="" onSubmit={handleSubmit}>
          <Col sm="12" md={12} className="d-block">
            <TableWithButtons
              columns={errorColumns}
              data={errorData}
            ></TableWithButtons>
          </Col>
        </Row>
      </Modal>
    </Col>
  )
}

export default SingleDebtEntry
